import { oc } from '@orpc/contract';
import { listImportBatchesInputSchema, listImportBatchesOutputSchema } from '../schemas/import.schemas.js';
export const listImportBatchesContract = oc
    .route({
    method: 'GET',
    path: '/import/batches',
    tags: ['Import'],
    summary: 'List past import batches with their uploader and row counts',
})
    .input(listImportBatchesInputSchema)
    .output(listImportBatchesOutputSchema);
//# sourceMappingURL=list-import-batches.contract.js.map